import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import ProductCategoryEntity from '../entities/ProductCategoryEntity';
import ProductCategoryState from '../store/ProductCategoryState';

const initialState: ProductCategoryState = {
    list: [],
    topSale: null,
};

export const productCategorySliceName = 'productCategory';
export const productCategorySlice = createSlice({
    name: productCategorySliceName,
    initialState,
    reducers: {
        setListProductCategories: (state, action: PayloadAction<ProductCategoryEntity[]>) => {
            state.list = action.payload;
        },
        setTopSaleProductCategory: (state, action: PayloadAction<ProductCategoryEntity | null>) => {
            state.topSale = action.payload;
        },
    },
    selectors: {
        getTopSaleProductCategorySelector: (state) => state.topSale,
    },
});

export const { setListProductCategories, setTopSaleProductCategory } = productCategorySlice.actions;
export const { getTopSaleProductCategorySelector } = productCategorySlice.selectors;
export const productCategoryReducer = productCategorySlice.reducer;
